import React, { useState, useEffect, useMemo } from "react";
import { GiSettingsKnobs } from "react-icons/gi";
import { RxCross1, RxCross2 } from "react-icons/rx";
import Select, { components } from "react-select";
import { reactSelectStyles } from "../../constants/StyleConstants";
import {
  days,
  sampleSelectionItems,
  years,
  months,
} from "./socialCalendarConstants";
import SocialDialog from "./SocialDialog";
import { categoryOptions } from "../../constants/SidebarConstants";

const FilterDialog = ({ onRegionFiltersChange, cities, zones, regions, setCities, setRegions, setZones }) => {
 

  useEffect(() => {
    onRegionFiltersChange({
      cities,
      zones,
      regions,
    });
  }, [cities, zones, regions]);

  return (
    <div className="w-full max-w-md bg-white text-gray-400 rounded-lg p-4">
      <p className="text-sm font-medium mb-2">City</p>
      <Select
        isMulti
        options={[
          { label: "Delhi", value: "Delhi" },
          { label: "Gurgaon", value: "Gurgaon" },
          { label: "Noida", value: "Noida" },
          { label: "Jaipur", value: "Jaipur" },
          { label: "Chennai", value: "Chennai" },
        ]}
        value={cities}
        onChange={setCities}
        styles={reactSelectStyles}
        placeholder="Select Cities"
      />

      {/* <p className="text-sm font-medium mt-4 mb-2">Zone</p>
      <Select
        isMulti
        options={[
          { label: "North", value: "North" },
          { label: "South", value: "South" },
          { label: "West", value: "West" },
        ]}
        value={zones}
        onChange={setZones}
        styles={reactSelectStyles}
        placeholder="Select Zones"
      /> */}

      {/* <p className="text-sm font-medium mt-4 mb-2">Region</p>
      <Select
        isMulti
        options={[
          { label: "Urban", value: "Urban" },
          { label: "Rural", value: "Rural" },
        ]}
        value={regions}
        onChange={setRegions}
        styles={reactSelectStyles}
        placeholder="Select Regions"
      /> */}
    </div>
  );
};


const SelectRegionAndOutlet = ({
  accounts,
  category,
  selectedOutlet,
  editable,
  setSelectedOutlet,
  setFieldValue,
  isCarousal,
  setCarousal,
  reshare,
  setReshare,
  isReel,
  selectedCategory,
  setSelectedCategory,
}) => {
  const [showAllSelectedOutlets, setShowAllSelectedOutlets] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
const [regionFilter, setRegionFilter] = useState({
  cities: [],
  zones: [],
  regions: [],
});
 const [cities, setCities] = useState([]);
  const [zones, setZones] = useState([]);
  const [regions, setRegions] = useState([]);
const handleRegionFiltersChange = (filters) => {
  setRegionFilter(filters);
};


  // Initialize selectedOutlet based on editedPost.accounts
  useEffect(() => {
    if (accounts?.length && !editable) {
      const formattedAccounts = accounts.map((a) => ({
        label: a.accountName,
        value: a._id,
      }));
      setSelectedOutlet(formattedAccounts);
    } else {
      setSelectedOutlet([]);
    }
  }, [accounts, setSelectedOutlet]);

  useEffect(() => {
    if (category && !editable) {
      const formattedCategory = {
        label: category,
        value: category,
      };
      setSelectedCategory(formattedCategory);
    } else {
      setSelectedCategory([]);
    }
  }, [category, setSelectedCategory]);

const outletOptions = useMemo(() => {
  const filtered = sampleSelectionItems.filter((item) => {
    const matchCity =
      regionFilter.cities.length === 0 ||
      regionFilter.cities.some((c) => c.value === item.city);

    const matchZone =
      regionFilter.zones.length === 0 ||
      regionFilter.zones.some((z) => z.value === item.zone);

    const matchRegion =
      regionFilter.regions.length === 0 ||
      regionFilter.regions.some((r) => r.value === item.region);

    return matchCity && matchZone && matchRegion;
  });

  return [{ label: "Select All", value: "select_all" }, ...filtered];
}, [regionFilter]);




 const handleSelectOutlet = (selectedOptions) => {
  const isSelectAll = selectedOptions?.some(
    (opt) => opt.value === "select_all"
  );

  if (isSelectAll) {
    // Use the filtered outlet options, excluding "Select All"
    const filteredOutlets = outletOptions.filter(
      (opt) => opt.value !== "select_all"
    );

    setSelectedOutlet(filteredOutlets);
    setFieldValue("accounts", filteredOutlets);
  } else {
    setSelectedOutlet(selectedOptions || []);
    setFieldValue("accounts", selectedOptions || []);
  }

  if ((selectedOptions || []).length <= 3) {
    setShowAllSelectedOutlets(false);
  }
};

  const handleSelectCategory = (selectedOptions) => {
    setSelectedCategory(selectedOptions);
    setFieldValue("category", selectedOptions.value);
  };

  const [showFilters, setShowFilters] = useState(false);

  const OutletPopup = ({
    selectedOutlet,
    outletOptions,
    handleSelectOutlet,
    setShowPopup,
  }) => {
    const [localSelected, setLocalSelected] = useState([...selectedOutlet]);
    const selectAllOption = { label: "Select All", value: "select_all" };
    const unselectedOptions = useMemo(() => {
      const selectedIds = new Set(localSelected.map((o) => o.value));
      return outletOptions.filter((o) => !selectedIds.has(o.value));
    }, [localSelected, outletOptions]);

    const handleAddOutlet = (selected) => {
      if (!selected) return;

      if (selected.value === "select_all") {
        // Use parent handler for Select All logic
        setLocalSelected(outletOptions);
        // setShowPopup(false);
      } else {
        // Add normal outlet
        setLocalSelected((prev) => [...prev, selected]);
      }
    };

    const handleRemoveOutlet = (id) => {
      setLocalSelected((prev) => prev.filter((o) => o.value !== id));
    };

    const handleApply = () => {
      handleSelectOutlet(localSelected);
      setShowPopup(false);
    };

    return (
      <div className=" w-[600px] bg-white rounded-lg p-4">
        <h1 className="text-lg font-semibold mb-2">Customize Outlets</h1>
        <p className="text-sm mb-4">Add or remove outlets below:</p>
        <div className="flex justify-between flex-row w-full mb-4 ">
          <div className="min-w-[300px]">
            <Select
              options={unselectedOptions}
              onChange={handleAddOutlet}
              styles={reactSelectStyles}
              placeholder="Add more outlets"
              className="scroll-style"
              isClearable
            />
          </div>

          <div className="selected-items flex flex-wrap items-center justify-end w-fit gap-2">
            {localSelected.map((item, i) => (
              <span
                key={i}
                className="text-[9px] w-fit whitespace-nowrap bg-[#e6f7ff] hover:bg-transparent flex items-center gap-2 text-[#007aff] border-[1.5px] border-[#00b3ff] py-1 px-2"
              >
                {item.label}
                <button
                  disabled={!editable}
                  onClick={() => handleRemoveOutlet(item.value)}
                  className="de-select h-[15px] cursor-pointer"
                >
                  <RxCross2
                    className={`${
                      !editable
                        ? "cursor-not-allowed"
                        : "cursor-pointer transition-all duration-700 ease-in-out "
                    } text-xs hover:font-bold hover:text-lg`}
                  />
                </button>
              </span>
            ))}
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button
            className="px-4 py-2 text-sm border border-gray-400 rounded"
            onClick={() => setShowPopup(false)}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 text-sm bg-blue-600 text-white rounded"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="max-w-[800px] min-w-[800px] flex flex-col gap-1">
      <SocialDialog
        width="w-[630px]"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        title="Select Outlets"
        content={
          <OutletPopup
            selectedOutlet={selectedOutlet}
            outletOptions={outletOptions}
            handleSelectOutlet={handleSelectOutlet}
            setShowPopup={setShowPopup}
          />
        }
      />

      <div className="flex items-center justify-between ">
        <h1 className="font-bold text-sm">Select Outlet</h1>
        <div className="selected-items  flex items-center gap-2">
        <div className="flex flex-wrap gap-2">
  {regionFilter?.cities?.length > 0 && (
    <span className="text-[9px] h-[25px] transition-all duration-700 ease-in-out  w-fit whitespace-nowrap bg-[#e6f7ff] hover:bg-transparent flex items-center gap-2 text-[#007aff] border-[1.5px] border-[#00b3ff] py-1 px-2">
      City
      <button
        disabled={!editable}
        onClick={() =>{
          setCities([])
          setRegionFilter((prev) => ({ ...prev, cities: [] }))}
          
        }
        className="de-select cursor-pointer"
      >
        <RxCross2
          className={`${
            !editable
              ? "cursor-not-allowed"
              : "hover:font-bold hover:text-lg transition-all duration-700 ease-in-out cursor-pointer"
          } text-xs`}
        />
      </button>
    </span>
  )}

  {regionFilter?.zones?.length > 0 && (
    <span className="text-[9px] h-[25px] transition-all duration-700 ease-in-out  w-fit whitespace-nowrap bg-[#e6f7ff] hover:bg-transparent flex items-center gap-2 text-[#007aff] border-[1.5px] border-[#00b3ff] py-1 px-2">
      Zone
      <button
        disabled={!editable}
        onClick={() =>{ setZones([])
          setRegionFilter((prev) => ({ ...prev, zones: [] }))}
        }
        className="de-select cursor-pointer"
      >
        <RxCross2
          className={`${
            !editable
              ? "cursor-not-allowed"
              : "hover:font-bold hover:text-lg transition-all duration-700 ease-in-out cursor-pointer"
          } text-xs`}
        />
      </button>
    </span>
  )}

  {regionFilter?.regions?.length > 0 && (
    <span className="text-[9px] h-[25px] transition-all duration-700 ease-in-out  w-fit whitespace-nowrap bg-[#e6f7ff] hover:bg-transparent flex items-center gap-2 text-[#007aff] border-[1.5px] border-[#00b3ff] py-1 px-2">
      Region
      <button
        disabled={!editable}
        onClick={() =>{
          setRegions([])
          setRegionFilter((prev) => ({ ...prev, regions: [] }))}
        }
        className="de-select cursor-pointer"
      >
        <RxCross2
          className={`${
            !editable
              ? "cursor-not-allowed"
              : "hover:font-bold hover:text-lg transition-all duration-700 ease-in-out cursor-pointer"
          } text-xs`}
        />
      </button>
    </span>
  )}
</div>

    <SocialDialog
  isOpen={showFilters}
  onClose={() => setShowFilters(false)}
  title="Sort & Filter"
  content={
    <FilterDialog onRegionFiltersChange={handleRegionFiltersChange} setCities={setCities} setZones={setZones} setRegions={setRegions} cities={cities} zones={zones} regions={regions}/>
  }
/>


          <button
            onClick={() => setShowFilters(true)}
            disabled={!editable}
            className={`${
              !editable
                ? "cursor-not-allowed"
                : "hover:-translate-y-1 transition-all duration-700 ease-in-out hover:bg-gray-200 cursor-pointer"
            }border-gray-400  border-opacity-50 border-[1.5px] py-1 px-2`}
          >
            <GiSettingsKnobs className="rotate-90 text-gray-500 font-bold text-sm" />
          </button>
        </div>
      </div>

      <div className="max-w-[800px] min-w-[800px]">
        <Select
          placeholder="Select"
          isMulti={true}
          value={selectedOutlet}
          onChange={handleSelectOutlet}
          options={outletOptions}
          styles={reactSelectStyles}
          isDisabled={!editable}
        />

        {selectedOutlet.length !== 0 && (
          <div className="flex justify-between items-start gap-2 mt-1">
            <div className="selected-items grid grid-cols-[repeat(3,auto)] w-fit gap-2">
              {(showAllSelectedOutlets
                ? selectedOutlet
                : selectedOutlet.slice(0, 3)
              ).map((item, i) => (
                <span
                  key={i}
                  className="text-[9px] w-fit whitespace-nowrap bg-[#e6f7ff] hover:bg-transparent flex items-center gap-2 text-[#007aff] border-[1.5px] border-[#00b3ff] py-1 px-2"
                >
                  {item.label}
                  <button
                    disabled={!editable}
                    onClick={() =>
                      setSelectedOutlet(
                        selectedOutlet?.filter(
                          (sItem) => sItem?.value !== item.value
                        )
                      )
                    }
                    className="de-select h-[15px] cursor-pointer"
                  >
                    <RxCross2
                      className={`${
                        !editable
                          ? "cursor-not-allowed"
                          : "cursor-pointer transition-all duration-700 ease-in-out "
                      } text-xs hover:font-bold hover:text-lg`}
                    />
                  </button>
                </span>
              ))}
            </div>

            {selectedOutlet.length > 1 && (
              // <button
              //   disabled={!editable}
              //   onClick={() => setShowAllSelectedOutlets((prev) => !prev)}
              //   className={`${
              //     !editable ? "cursor-not-allowed" : "cursor-pointer"
              //   } btn-1 rounded-sm font-normal bg-[#007aff] text-xs h-[10px] p-[1px]`}
              // >
              //   {showAllSelectedOutlets ? "Less" : "More"}
              // </button>
              <button
                disabled={!editable}
                onClick={() => setShowPopup(true)}
                className={`${
                  !editable ? "cursor-not-allowed" : "cursor-pointer"
                } btn-1 rounded-sm font-normal bg-[#007aff] text-xs h-[10px] p-[1px]`}
              >
                {showAllSelectedOutlets ? "Less" : "More"}
              </button>
            )}
          </div>
        )}
        <div className="flex  items-center mt-2 w-[70%] justify-between">
          <div className="flex items-center gap-2">
            {/* Left: Category Dropdown */}
            <div className="min-w-[100px]">
              <Select
                options={categoryOptions}
                styles={reactSelectStyles}
                value={selectedCategory}
                onChange={handleSelectCategory}
                isDisabled={!editable}
                placeholder="Select Category"
              />
            </div>

            {/* Center: Carousel Toggle */}
            {isReel && (
              <div className="flex items-center gap-3">
                <span className="text-xs text-gray-500 whitespace-nowrap">
                  Post as Carousel
                </span>
                <label
                  className="preview-toggle text-[3px]"
                  style={{ marginBottom: "0px" }}
                >
                  <input
                    type="checkbox"
                    checked={isCarousal}
                    onChange={(e) => setCarousal(e.target.checked)}
                    disabled={!editable}
                  />
                  <span className="preview-slider" />
                </label>
              </div>
            )}
          </div>
          {/* Right: Reshare Toggle */}
          <div className="flex items-center gap-1">
            <input
              type="checkbox"
              id="reshare"
              checked={reshare}
              onChange={(e) => setReshare(e.target.checked)}
              className="w-3 h-3"
              disabled={!editable}
            />
            <label
              htmlFor="reshare"
              className="text-xs cursor-pointer text-gray-500 whitespace-nowrap"
            >
              Reshare the post in story
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectRegionAndOutlet;
